import { render, staticRenderFns } from "./ClipPost.vue?vue&type=template&id=7f18b76f&"
import script from "./ClipPost.vue?vue&type=script&lang=ts&"
export * from "./ClipPost.vue?vue&type=script&lang=ts&"
import style0 from "./ClipPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports